<template>
    <div class="comments_list" v-loading="loading">
       <div class="comments_list_box">
            <div class="top_box">
                <img src="@/assets/img/login/Frame.png" alt="">
                <span class="span1" @click="handle_home">首页</span>
                > 裁判点评
            </div>
            <div class="check_box">
                <div class="check_felx">
                    <div class="check_title">纠纷发生地</div>
                    <div class="check_list" :class="{'check_list_minh':jffsd_show,'check_list_maxh':!jffsd_show}">
                        <div class="check_item" :class="{check_item_ac:item.id==jffsd_ac.id}" v-for="(item,index) in jffsd_list" :key="index" @click="handle_jffsd_ac(item)">{{ item.name }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':jffsd_show}" @click="handle_jffsd_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>
                <div class="check_felx">
                    <div class="check_title">委托人住所地</div>
                    <div class="check_list" :class="{'check_list_minh':wtrszd_show,'check_list_maxh':!wtrszd_show}">
                        <div class="check_item" :class="{check_item_ac:item.id==wtrszd_ac.id}" v-for="(item,index) in wtrszd_list" :key="index" @click="handle_wtrszd_ac(item)">{{ item.name }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':wtrszd_show}" @click="handle_wtrszd_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>
                <div class="check_felx">
                    <div class="check_title">一级分类</div>
                    <div class="check_list" :class="{'check_list_minh':yjfl_show,'check_list_maxh':!yjfl_show}">
                        <div class="check_item" :class="{check_item_ac:item.id==yjfl_ac.id}" v-for="(item,index) in yjfl_list" :key="index" @click="handle_yjfl_ac(item)">{{ item.title }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':yjfl_show}" @click="handle_yjfl_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>
                <div class="check_felx">
                    <div class="check_title">二级分类</div>
                    <div class="check_list" :class="{'check_list_minh':ejfl_show,'check_list_maxh':!ejfl_show}">
                        <div class="check_item" :class="{check_item_ac:item.id==ejfl_ac.id}" v-for="(item,index) in ejfl_list" :key="index"  @click="handle_ejfl_ac(item)">{{ item.title  }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':ejfl_show}" @click="handle_ejfl_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>
                <div class="check_felx">
                    <div class="check_title">三级分类</div>
                    <div class="check_list" :class="{'check_list_minh':sjfl_show,'check_list_maxh':!sjfl_show}">
                        <div class="check_item" :class="{check_item_ac:item.id==sjfl_ac.id}" v-for="(item,index) in sjfl_list" :key="index" @click="handle_sjfl_ac(item)">{{ item.title  }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':sjfl_show}" @click="handle_sjfl_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>

                <div class="check_felx">
                    <div class="check_title">已选择</div>
                    <div class="check_ac_flex">
                        <div class="check_ac_box" v-if="jffsd_ac.id">
                            {{ jffsd_ac.name }}
                            <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('jffsd_ac')">
                        </div>
                        <div class="check_ac_box" v-if="wtrszd_ac.id">
                            {{ wtrszd_ac.name }}
                            <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('wtrszd_ac')">
                        </div>
                        <div class="check_ac_box" v-if="yjfl_ac.id">
                            {{ yjfl_ac.title }}
                            <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('yjfl_ac')">
                        </div>
                        <div class="check_ac_box" v-if="ejfl_ac.id">
                            {{ ejfl_ac.title }}
                            <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('ejfl_ac')">
                        </div>
                        <div class="check_ac_box" v-if="sjfl_ac.id">
                            {{ sjfl_ac.title }}
                            <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('sjfl_ac')">
                        </div>
                        <!-- <div class="check_ac_text"></div> -->
                        <div class="chack_ac_clear" @click="handle_qk">清空</div>
                    </div>
                </div>
            </div>
            <div class="list_box">
                <div class="list_item">
                    <div class="item" v-for="(item,index) in list" :key="index" >
                        <div class="title_flex">
                            <div class="titles">
                                {{ item.title }}
                            </div>
                            <div class="teges">
                                <img src="@/assets/img/index/comments_case/grade_c.png" alt="" v-if="item.grade==1">
                                <img src="@/assets/img/index/comments_case/grade_z.png" alt="" v-if="item.grade==2">
                                <img src="@/assets/img/index/comments_case/grade_g.png" alt="" v-if="item.grade==3">
                                <img src="@/assets/img/index/comments_case/grade_t.png" alt="" v-if="item.grade==4">
                            </div>
                        </div>
                        <div class="jianjie">
                            {{ item.trial_obj }}
                            <span  @click="handle_xdp(item)">阅读全文</span>
                        </div>
                        <div class="btns_flex">
                            <div class="btns_left">
                                <div class="btns1">
                                    <img src="@/assets/img/index/comments_case/zan.png" alt="">
                                    &nbsp;
                                    赞同
                                    &nbsp;
                                    {{ item.good_num }}
                                </div>
                                <div class="btns2">
                                    <img src="@/assets/img/index/comments_case/cai.png" alt="">
                                </div>
                                <div class="btns3">
                                    <img src="@/assets/img/index/comments_case/pl_num.png" alt="">
                                    {{item.comment_num}}条评论
                                </div>
                            </div>
                            <div class="btns_right">
                                <div class="btns1" @click="handle_xdp(item)" v-if="item.is_comment==1">
                                    <img src="@/assets/img/index/comments_case/pl.png" alt="" class="img1">
                                    <img src="@/assets/img/index/comments_case/pl2.png" alt="" class="img2">
                                    写点评
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="pages_box">
                        <div class="btns" @click="handle_pages(1)">首页</div>
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pages.page"
                            background
                            :page-size="pages.limit"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                        <div class="btns"  @click="handle_pages(10)">尾页</div>
                    </div>
                </div>
                <div class="list_nuw">
                    <comments_list_right ref="comments_list_right"></comments_list_right>
                </div>

            </div>
       </div>  
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'

import comments_list_right from '@/components/comments/comments_list_right.vue'//右边


export default {
    components: {
        comments_list_right
    },
    name: "homes",
    data() {
        return {
            loading:false,
            jffsd_list:'',//纠纷发生地列表
            jffsd_ac:{},//纠纷发生地选中
            jffsd_show:'',//纠纷发生地的显示隐藏
            
            wtrszd_list:'',//委托人住所地列表
            wtrszd_ac:{},//委托人住所地选中
            wtrszd_show:'',//委托人住所地的显示隐藏

            yjfl_list:'',//一级分类列表
            yjfl_ac:{},//一级分类选中
            yjfl_show:'',//一级分类的显示隐藏

            ejfl_list:'',//二级分类列表
            ejfl_ac:{},//二级分类选中
            ejfl_show:'',//二级分类的显示隐藏
            
            sjfl_list:'',//三级分类列表
            sjfl_ac:{},//三级分类选中
            sjfl_show:'',//三级分类的显示隐藏
            list:[],
            total:0,
            last_page:0,
            pages:{
                page:1,
                limit:10,
            },
            banner_ac:0,
            banner_list:[1,2,3]
          
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_list()
        this.get_area()
        this.get_cause_list()
    },
    methods: {
        get_area(){
            this.loading=true
            this.$api("getChinaArea", {
                parent_id:1,
				type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.jffsd_list=res.data
                    this.wtrszd_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        //获取分类
        get_cause_list(){
            this.loading=true
            this.$api("cause", {
				
			}, "get").then((res) => {
                this.loading = false
                console.log('案由',res)
                if (res.code == 1) {
                    this.yjfl_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handleSizeChange(e){
            console.log('条数',e)
        },
        handleCurrentChange(e){
            console.log(' 页数',e)
            this.pages.page=e
            this.get_list()
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
            this.get_list()

        },
        handle_home(){
            this.$router.push({
                path:'/home',
            })
        },
        handle_jffsd_show(){
            this.jffsd_show=!this.jffsd_show
        },
        handle_wtrszd_show(){
            this.wtrszd_show=!this.wtrszd_show
        },
        handle_yjfl_show(){
            this.yjfl_show=!this.yjfl_show
        },
        handle_ejfl_show(){
            this.ejfl_show=!this.ejfl_show
        },
        handle_sjfl_show(){
            this.sjfl_show=!this.sjfl_show
        },
        change_banner(e){
            // console.log('却换触发',e)
            this.banner_ac=e
        },
        handle_jffsd_ac(item){
            this.jffsd_ac=item
            this.pages.page=1
            this.get_list()
        },
        handle_wtrszd_ac(item){
            this.wtrszd_ac=item
            this.pages.page=1
            this.get_list()
        },
        handle_yjfl_ac(item){
            this.yjfl_ac=item
            this.ejfl_list=item.child
            this.ejfl_ac={}
            this.sjfl_list=[]
            this.sjfl_ac={}
            this.pages.page=1
            this.get_list()
        },
        handle_ejfl_ac(item){
            this.ejfl_ac=item
            this.sjfl_list=item.child
            this.sjfl_ac={}
            this.pages.page=1
            this.get_list()
            
        },
        handle_sjfl_ac(item){
            this.sjfl_ac=item
            this.pages.page=1
            this.get_list()
        },
        ac_clear(text){
            this[text]={}
            if(text=='yjfl_ac'){
                this.ejfl_list=[]
                this.ejfl_ac={}
                this.sjfl_list=[]
                this.sjfl_ac={}
            }
            if(text=='ejfl_ac'){
                this.sjfl_list=[]
                this.sjfl_ac={}
            }
            this.pages.page=1
            this.get_list()
 
        },
        handle_qk(){
            this.jffsd_ac={}
            this.wtrszd_ac={}
            this.yjfl_ac={}
            this.ejfl_ac={}
            this.ejfl_list=[]
            this.sjfl_ac={}
            this.sjfl_list=[]
            this.pages.page=1
            this.get_list()
        },
        handle_clear(){
            this.jffsd_ac={}
            this.wtrszd_ac={}
            this.yjfl_ac={}
            this.ejfl_ac={}
            this.sjfl_ac={}
            this.ejfl_list=[]
            this.sjfl_list=[]
            this.pages.page=1
            this.get_list()
        },
        get_list(){
            this.loading = true
            this.$api("caseList", {
                ...this.pages,
                anliku:0,//是否为案例库
                happen_province:this.jffsd_ac.name||'',//发生地所在省
                province:this.wtrszd_ac.name||'',//委托人所在省
                cateid:this.yjfl_ac.id||'',//一级分类
                cateid2:this.ejfl_ac.id||'',//二级费雷
                cateid3:this.sjfl_ac.id||'',//三级分类
                
			}, "get").then((res) => {
                this.loading = false
                console.log('案例库',res)
                if (res.code == 1) {
                   this.list=res.data.data
                   this.last_page=res.data.last_page
                   this.total=res.data.total
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_xdp(item){
            this.$router.push({
                path:'/comments_detial',
                query:{
                    id:item.id
                }
            })
        },
    },

}
</script>
<style scoped lang="less">
.comments_list{
    padding-bottom: 100px;
    background-color: #F5F5F5;
    .comments_list_box{
        width: 1440px;
        margin: auto;
        .top_box{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding: 20px 0;

            .span1 {
                cursor: pointer;
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }
        .check_box{
            width: 1440px;
            // height: 261px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            padding:0 32px;
            .check_felx{
                display: flex;
                // align-items: center;
                padding: 24px 0px 14px 0;
                border-bottom: 1px solid #EEEEEE ;
                .check_title{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                    width: 90px;
                    flex-shrink: 0;
                }
                .check_list{
                    display: flex;
                    flex-wrap: wrap;
                    width: 1260px;
                    .check_item{
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        margin-right: 40px;
                        margin-bottom: 10px;
                        &:hover{
                            color: #377CFD;
                        }
                    }
                    .check_item_ac{
                        color: #377CFD;
                    }
                }
                .check_list_maxh{
                    height: 60px;
                    overflow: hidden;
                }
                .check_list_minh{
                    min-height: 60px;
                }
                .check_show{
                    width: 20px;
                    height: 20px;
                    flex-shrink: 0;
                    img{
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                    }
                }
                .check_show2{
                    img{
                        transform: rotate(-180deg);
                    }
                }
                .check_ac_flex{
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    .check_ac_box{
                        // width: 102px;
                        padding: 0 10px;
                        height: 29px;
                        background: #F8F8F8;
                        border-radius: 0px 0px 0px 0px;
                        margin-right: 11px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        
                        font-weight: 400;
                        font-size: 14px;
                        color: #656565;
                        img{
                            width: 12px;
                            height: 12px;
                            margin-left: 14px;
                            cursor: pointer;
                        }

                    }
                    .chack_ac_clear{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        cursor: pointer;
                    }
                }
            }
        }
        .list_box{
            margin-top:20px ;
            display: flex;
            justify-content: space-between;
            .list_item{
                width: 1000px;
                padding: 40px;
                background-color: #FFFFFF;
                .item{
                    padding-bottom: 13px;
                    border-bottom: 1px solid #D9D9D9;
                    margin-bottom: 32px;
                    .title_flex{
                        display: flex;
                        align-items: center;
                        padding-bottom: 24px;
                        .titles{
                            max-width: 600px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 24px;
                            color: #333333;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;
                        }
                        .teges{
                            display: flex;
                            align-items: center;
                            margin-left: 23px;
                            img{
                                width: 70px;
                                height: 25px;
                            }
                        }
                    }
                    .jianjie{
                        
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        span{
                            color: #377CFD;
                            cursor: pointer;
                        }
                    }
                    .btns_flex{
                        display: flex;
                        justify-content: space-between;
                        padding-top: 24px;
                        .btns_left{
                            display: flex;
                            align-items: center;
                            padding-bottom: 19px;
                            .btns1{
                                // width: 124px;
                                padding: 0 21px;
                                height: 36px;
                                background: #377CFD;
                                background:rgba(55, 124, 253, 0.08);
                                border-radius: 4px 4px 4px 4px;
                                // opacity: 0.08;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                cursor: pointer;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #377CFD;
                                img{
                                    width:14px ;
                                    height: 14px;
                                }

                            }
                            .btns2{
                                width: 36px;
                                height: 36px;
                                background:rgba(55, 124, 253, 0.08);
                                border-radius: 4px 4px 4px 4px;
                                margin-left: 8px;
                                cursor: pointer;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                img{
                                    width:14px ;
                                    height: 14px;
                                }
                            }
                            .btns3{
                                margin-left: 24px;
                                display: flex;
                                align-items: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;


                                img{
                                    // width:13px ;
                                    height: 11px;
                                    margin-right:8px ;
                                }
                            }
                        }
                        .btns_right{
                            .btns1{
                                width: 134px;
                                height: 36px;
                                background: #FFFFFF;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #BABABA;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                cursor: pointer;
                                img{
                                    width:14px ;
                                    height: 14px;
                                    margin-right: 3px;
                                }
                                .img1{
                                    display: none;
                                }
                                &:hover{
                                    border: 1px solid #377CFD;
                                    background: #377CFD;
                                    color: #FFFFFF;
                                    .img1{
                                        display: block;
                                    }
                                    .img2{
                                        display: none;

                                    }
                                }
                            }
                        }
                    }
                }

                .pages_box{
                    width: 100%;
                    height: 100px;
                    // background-color: red;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    /deep/.el-pagination{
                        .el-pager{
                            .number {
                                background-color: #FFFFFF;
                                border: 1px solid #EEEEEE;
                            }
                            .active{
                                background-color: #377CFD;
                            }
                        }
                    }
                    .btns{
                        width: 40px;
                        height: 32px;
                        background: #FFFFFF;
                        border-radius: 4px 4px 4px 4px;
                        border: 1px solid #EEEEEE;  
                        font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                        font-weight: normal;
                        font-size: 14px;
                        color: #7A7A7A;
                        text-align: center;
                        line-height: 32px;
                        cursor: pointer;
                    }
                }
            }
            .rights_box{
                width: 420px;
                min-height: 100px;
                // background-color: red;
                .r_top{
                    width: 420px;
                    height: 300px;
                    position: relative;
                    padding: 32px 36px;
                    // background-image: url("@/assets/img/index/legal/r_top_bg.png" );
                    background-image: url('../../../assets/img/index/legal/r_top_bg.png');
                    background-size: 100%;
                    // .imgs{
                    //     width: 420px;
                    //     height: 300px;
                    //     position: absolute;
                    //     left: 0;
                    //     top: 0;
                    // }
                    .titles{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 24px;
                        color: #333333;

                    }
                    .text1{
                        padding-top: 14px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;

                    }
                    .nums{
                        padding-top: 20px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 36px;
                        color: #377CFD;

                    }
                    .text2{
                      
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;

                    }
                    .btns_box{
                        padding-top: 40px;
                        .btns{
                            width: 180px;
                            height: 40px;
                            background: #377CFD;
                            box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                            border-radius: 4px 4px 4px 4px;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;
                        }
                    }
                }
                .r_bom{
                    width: 420px;
                    height: 460px;
                    // background: red;
                    margin-top: 24px;
                    position: relative;
                    .banner_title{
                        position: absolute;
                        top: 24px;
                        left: 32px;
                        display: flex;
                        align-items: center;
                        z-index: 100;           
                        font-weight: bold;
                        font-size: 18px;
                        color: #FFFFFF;
                    }
                    .change_box{
                        position: absolute;
                        top: 32px;
                        right: 32px;
                        display: flex;
                        align-items: center;
                        z-index: 100;
                        .change_item{
                            width: 6px;
                            height: 6px;
                            background: #F2F2F5;
                            border-radius: 50%;
                            margin-left: 6px;
                        }
                        .change_item_ac{
                            background: #377CFD;
                        }
                    }
                    /deep/.el-carousel{
                        width: 100%;
                        height: 100%;
                        .el-carousel__container{
                            width: 100%;
                            height: 100%;
                            .banner_box{
                                width: 100%;
                                height: 100%;
                                background-image: url('../../../assets/img/index/legal/banner_bg.png');
                                background-size: 100%;
                                padding-top: 88px;
                                .borders_box{
                                    width: 160px;
                                    height: 160px;
                                    margin: auto;
                                    border-radius: 50%;
                                    // margin-top: 88px; 
                                    // background: #FFFFFF;
                                    // opacity: 0.2;
                                    position: relative;
                                    .borders1{
                                        width: 160px;
                                        height: 160px;
                                        background: #FFFFFF;
                                        opacity: 0.2;
                                        position: absolute;
                                        left: 0;
                                        top: 0;
                                        z-index: 1;
                                        border-radius: 50%;

                                    }
                                    .borders2{
                                        width: 132px;
                                        height: 132px;
                                        background: #C4C4C4;
                                        position: absolute;
                                        left: 50%;
                                        top: 50%;
                                        z-index: 2;
                                        border-radius: 50%;

                                        transform: translate(-50%,-50%);
                                        img{
                                            width: 132px;
                                            height: 132px;
                                            border-radius: 50%;

                                        }
                                    }
                                    .tage_box{
                                        width: 100%;
                                        position: absolute;
                                        z-index: 3;
                                        bottom: -4px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        .tages{
                                            cursor: pointer;
                                            width: 104px;
                                            height: 32px;
                                            background: linear-gradient( 180deg, #FAECC6 0%, #F2CF85 100%);
                                            border-radius: 16px 16px 16px 16px;
                                            border: 1px solid #876052;
                                            font-family: Microsoft YaHei, Microsoft YaHei;
                                            font-weight: 400;
                                            font-size: 14px;
                                            color: #6C3E2D;
                                            text-align: center;
                                            line-height: 32px;
                                        }
                                    }
                                    
                                }
                                .ls_name{
                                    padding-top: 28px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 24px;
                                    color: #FFFFFF;
                                    text-align: center;
                                }
                                .ls_texts{
                                    padding-top: 14px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #FFFFFF;
                                    text-align: center;
                                }   
                                .btns_flex{
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    padding-top: 40px;
                                    .btns{
                                        width: 180px;
                                        height: 40px;
                                        background: #377CFD;
                                        box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                                        border-radius: 4px 4px 4px 4px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        line-height: 40px;
                                        text-align: center;
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: bold;
                                        font-size: 14px;
                                        color: #FFFFFF;
                                        cursor: pointer;
                                        img{
                                            width: 14px;
                                            height: 14px;
                                            margin-right: 10px;
                                        }
                                    }
                                }
                            }
                        }
                        .el-carousel__indicators{
                            //  display: none;
                        }
                    }
                }
            }
        }
    }
    
   
    
}

</style>